import React from 'react';
import './MissionStatement.css';
import Container from './Container';
const MissionStatement = () => {
  return (
    <section className="mission-section">
      <Container>
      <div className="mission-container">
        <div className="mission-content">
          <h2>ELDR Global Mission Statement</h2>
          
          <p className="mission-intro">
            At ELDRdigrey, we are committed to providing both death- and lifetime-secure Private and 
            Medical document storage that travels alongside your passerby for journey year after year.
          </p>

          <p>
            ELDR accomplishes this, through innovation, simplicity and transparency. Our team works hard 
            daily for you in an effort to do the following:
          </p>

          <ul className="mission-list">
            <li>It is to empower individuals, families and organization by providing:</li>
            <li>Portable access to personal Medical and Advance directive, anywhere, anytime</li>
            <li>Privacy and Security with controlled access to care providers, organization and relatives</li>
            <li>A trusted healthcare system and support network where an individual can get help anytime, anywhere</li>
            <li>Access to a host of Legal and Medical resources for wellness and place of mind</li>
            <li>Ability to reduce family uncertainty and Inter-family anxiety</li>
            <li>Peace of mind for you and your family members living</li>
            <li>With ELDR, you will no longer have fragmented medical history across multiple doctors, facilities, Digital State, meaning, lab and vital reported by your preference.</li>
          </ul>

          <button className="mission-read-more-btn">Read More</button>
        </div>

        <div className="mission-image">
          <img 
            src="https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=600&h=500&fit=crop" 
            alt="Mission hexagon diagram" 
          />
          <div className="mission-overlay">
            <div className="mission-center">MISSION</div>
          </div>
        </div>
      </div>
      </Container>
    </section>
  );
};

export default MissionStatement;
